"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _RadarChart = _interopRequireDefault(require("../../RadarChart/RadarChart"));
var _OrganisationMember = _interopRequireDefault(require("../../OrganisationMember/OrganisationMember"));
var _DownloadLinkBox = _interopRequireDefault(require("../../DownloadLinkBox/DownloadLinkBox"));
var _List = _interopRequireDefault(require("../../List/List"));
var _PhoneFormatter = _interopRequireDefault(require("../../../../common/Formatters/PhoneFormatter"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.inapp-SIASection-container .grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 48px; }\n\n.inapp-SIASection-container .downloadlink-container p {\n  width: 100%; }\n\n.inapp-SIASection-container .item-list {\n  display: flex;\n  justify-content: center;\n  gap: 86px; }\n  .inapp-SIASection-container .item-list .item .number {\n    font-size: 54px; }\n  .inapp-SIASection-container .item-list .item .label {\n    font-size: 14px; }\n  .inapp-SIASection-container .item-list .item .women-color {\n    margin-top: 16px;\n    width: 16px;\n    height: 16px;\n    background-color: #8caddb; }\n  .inapp-SIASection-container .item-list .item .men-color {\n    margin-top: 16px;\n    width: 16px;\n    height: 16px;\n    background-color: #dacd7e; }\n\n.inapp-SIASection-container .section-info {\n  display: flex;\n  gap: 48px;\n  justify-content: space-between; }\n\n.inapp-SIASection-container .OrganisationMember-container {\n  margin: 0px;\n  max-width: 244px; }\n\n.inapp-SIASection-container .right-content {\n  width: 100%; }\n\n.inapp-SIASection-container .bx--accordion__title {\n  color: #e41b13;\n  font-family: 'Helvetica Neue LT Roman';\n  font-size: 16px;\n  margin-left: 0px; }\n\n.inapp-SIASection-container .bx--accordion__heading:focus::before {\n  border-width: 0px; }\n\n.inapp-SIASection-container .bx--accordion__heading:hover::before {\n  opacity: 0.3; }\n\n.inapp-SIASection-container .bx--accordion__item:nth-child(1) {\n  border-top: none; }\n\n.inapp-SIASection-container .bx--accordion__content {\n  padding-right: 16px; }\n\n.inapp-SIASection-container .chart-holder {\n  margin: auto; }\n\n.inapp-SIASection-container .list-container {\n  padding-right: 64px; }\n\n@media (max-width: 66rem) {\n  .inapp-SIASection-container .section-info {\n    flex-direction: column; }\n    .inapp-SIASection-container .section-info .info-container {\n      margin-left: 0px; }\n  .inapp-SIASection-container .item-list {\n    flex-direction: column;\n    align-items: center;\n    gap: 48px; } }\n\n@media (max-width: 42rem) {\n  .inapp-SIASection-container .grid {\n    grid-template-columns: 100%; } }\n";
  const fileName = "InAppSIASection_InAppSIASection";
  const element = document.querySelector("style[data-sass-component='InAppSIASection_InAppSIASection']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const LeftContent = _ref => {
  let {
    data,
    translate,
    lang,
    history
  } = _ref;
  const presidents = data?.information?.president;
  const secretariat = data?.information?.secretariat;
  const secretariat_items = secretariat?.length > 0 && secretariat[0];
  const accordions = Object.entries(data?.information?.accordion || {});
  const delegates = accordions.find(el => el[0] === 'delegates');
  const delegatesItems = delegates ? delegates[1]?.map(el => ({
    content: [el.lastname + ' ' + el.firstname, el.diploma_title, el.city, el.role].filter(Boolean).join(', ')
  })) : [];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-container"
  }, /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
    items: [{
      link: {
        original_url: `https://www.sia.ch/${lang}/directory?sections=${data.id}`,
        url: `https://www.sia.ch/${lang}/directory?sections=${data.id}`,
        title: translate('cms.inapp.sections.directory')
      }
    }],
    lang: lang,
    isCMS: false
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "section-info sia-margin-02-bottom"
  }, secretariat && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-07"
  }, translate('cms.inapp.sections.secretariat')), Array.from({
    length: 8
  }, (v, i) => i).map(i => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: i
    }, secretariat_items['address_line_' + i] && /*#__PURE__*/_react.default.createElement("p", {
      className: "sia-text-08"
    }, secretariat_items['address_line_' + i]));
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-08 sia-padding-02-top sia-padding-02-bottom"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: `tel:${secretariat_items.phone?.replaceAll(' ', '')}`
  }, _PhoneFormatter.default.format(secretariat_items.phone)))), /*#__PURE__*/_react.default.createElement("div", null, presidents && presidents.map((president, i) => /*#__PURE__*/_react.default.createElement(_OrganisationMember.default, _extends({
    key: i
  }, president, {
    sia_membership: president.member_type,
    professional_group_membership: president?.professional_group[0]?.name,
    section_memberships: president.sections?.map(section => section.name),
    picture: president.image ? 'data:image/png;base64,' + president.image : null
  }))))), /*#__PURE__*/_react.default.createElement(_List.default, {
    title: translate('cms.inapp.sections.delegates'),
    items: delegatesItems
  }));
};
const min = (a, b) => a < b ? a : b;
const Chart = /*#__PURE__*/_react.default.memo(_ref2 => {
  let {
    ...args
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_RadarChart.default, args);
});
const RightContent = _ref3 => {
  let {
    data,
    translate
  } = _ref3;
  const [width, setWidth] = (0, _react.useState)(0);
  const [height, setHeight] = (0, _react.useState)(0);
  const ref = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    const widthAux = ref?.current ? ref.current.clientWidth : 300;
    setWidth(widthAux);
    setHeight(min(widthAux * 0.75, 350));
  }, []);
  const args = {
    colors: {
      Men: 'SIAyellow',
      Women: 'SIAazure'
    },
    width: `${width}px`,
    height: `${height}px`,
    fillMode: 'low',
    showTotal: true
  };
  const stats = data?.stats?.section_stats && data?.stats?.section_stats[0];
  const chartItems = _react.default.useMemo(() => {
    if (data?.stats && Object.entries(data?.stats).length > 4 && Object.entries(data?.stats)?.every(el => el[1]?.length > 0)) {
      return {
        Men: Object.fromEntries(Object.entries(data.stats).filter(_ref4 => {
          let [key, value] = _ref4;
          return !key.includes('section_stats');
        })?.map(_ref5 => {
          let [key, value] = _ref5;
          return [key, value[0].total_men];
        })),
        Women: Object.fromEntries(Object.entries(data.stats).filter(_ref6 => {
          let [key, value] = _ref6;
          return !key.includes('section_stats');
        })?.map(_ref7 => {
          let [key, value] = _ref7;
          return [key, value[0].total_women];
        }))
      };
    }
    return {};
  }, [data]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "right-content sia-padding-02-top"
  }, stats && /*#__PURE__*/_react.default.createElement("div", {
    className: "item-list sia-padding-04-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "item"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-14 number"
  }, stats.total_women + stats.total_men), /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-11 label"
  }, translate('cms.inapp.sections.members'))), /*#__PURE__*/_react.default.createElement("div", {
    className: "item"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-14 number"
  }, stats.total_women), /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-11 label"
  }, translate('cms.inapp.sections.women')), /*#__PURE__*/_react.default.createElement("div", {
    className: "women-color"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "item"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-14 number"
  }, stats.total_men), /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-11 label"
  }, translate('cms.inapp.sections.men')), /*#__PURE__*/_react.default.createElement("div", {
    className: "men-color"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "chart-container",
    ref: ref,
    style: {
      minHeight: `${height}px`
    }
  }, !!(chartItems?.Men && chartItems?.Women) && height && /*#__PURE__*/_react.default.createElement(Chart, _extends({}, args, {
    items: chartItems
  }))));
};
const InAppSIASection = _ref8 => {
  let {
    translate,
    lang,
    data,
    history
  } = _ref8;
  if (!data) console.error('NO InAppSIASection DATA');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "inapp-SIASections-container sia-border-01-bottom sia-padding-05-bottom sia-margin-02-bottom"
  }, data && /*#__PURE__*/_react.default.createElement("div", {
    className: "grid"
  }, /*#__PURE__*/_react.default.createElement(LeftContent, {
    data: data,
    translate: translate,
    lang: lang,
    history: history
  }), /*#__PURE__*/_react.default.createElement(RightContent, {
    data: data,
    translate: translate
  })));
};
var _default = exports.default = InAppSIASection;